<template lang="pug">
  .ColorSelect(
    @click='showOptions = !showOptions',
    v-click-outside='hide')
    .Select
      span.Select-values
        .Select-icon.Select-icon--bg(
          v-for='color in value',
          :style="{background: color.hex}")
        // {{value ? '' : 'Выберите цвет'}}
      span.Select-arrow(:class="{'Select-arrow--grey': arrowColor === 'grey'}")
        i.Icon.IconChevronDown

    .Options(v-if='showOptions', :style='{ width:  dropdownWidth }')
      .Option(v-for="option in options", @click="$event.stopImmediatePropagation()")
        .Select-icon.Select-icon--bg(
          :class="{'Select-icon--selected': value[option.id]}"
          @click='toggleOption($event, option)',
          :style="{background: option.hex}")

</template>

<script>
import ClickOutside from 'vue-click-outside'
import Vue from 'vue'

export default {
  name: 'color-select',
  data() {
    return {
      showOptions: false,
      value: {}
    }
  },
  props: {
    options: Array,
    initialValue: Array,
    isMultiple: false,
    dropdownWidth: '200px',
    arrowColor: 'default'
  },
  directives: {
    ClickOutside
  },
  mounted() {
    this.generateValues(this.initialValue)
  },
  watch: {
    initialValue(newVal) {
      this.generateValues(newVal)
    }
  },
  methods: {
    generateValues(initial) {
      this.value = {}
      initial.forEach((v) => {
        const fullValue = this.options.filter((option) => option.id === v)[0]
        if (fullValue) this.value[v] = fullValue
      })
    },
    toggleOption(e, option) {
      e.stopImmediatePropagation()
      if (this.value[option.id]) {
        Vue.delete(this.value, option.id)
      } else {
        if (this.isMultiple) {
          Vue.set(this.value, option.id, option)
        } else {
          this.value = {
            [option.id]: option
          }
        }
      }
      this.$emit('input', Object.keys(this.value))
    },
    hide() {
      this.showOptions = false
    }
  }
}
</script>
<style lang="scss">
@import '~base';
#app .ColorSelect,
.Popup .ColorSelect {
  --headerBorderBottom: #{$grey3};
  --arrowColor: #{$grey1};
  --optionsBorder: #{$grey3};
  --optionsBg: #{$white2};
  --optionsHoverBg: #{$grey3};
  --selectedBg: #{$grey7};
  --shadowColor: rgba(96, 104, 115, 0.2);
  --selectedBorder: transparent;
}

#app[data-theme='dark'] .ColorSelect,
.Popup[data-theme='dark'] .ColorSelect {
  --headerBorderBottom: #{$grey2};
  --arrowColor: #{$grey1};
  --optionsBorder: #{$black4};
  --optionsBg: #{$black3};
  --optionsHoverBg: #{$black2};
  --selectedBg: #{$black3};
  --shadowColor: transparent;
  --selectedBorder: #{$black4};
}
</style>
<style scoped lang="scss">
@import '~base';
.ColorSelect {
  position: relative;
  display: block;
  width: 100%;
  max-width: 100%;
  height: 100%;
  color: var(--basicText);
}

.Select {
  position: relative;
  display: flex;
  height: 100%;
  align-items: center;
  padding: 0 0.3rem 0 0.7rem;
  background: var(--selectedBg);
  border: 1px solid var(--selectedBorder);
  border-radius: 14px;

  &-icon {
    width: 20px;
    height: 20px;
    margin: 5px;
    border-radius: 50%;

    &--selected {
      border: 3px solid var(--accentColor);
    }
  }

  &-values {
    flex: 1 1 auto;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;
    line-height: 26px;
    margin-left: -5px;
  }

  &-arrow {
    flex: 0 0 25px;
    width: 25px;
    font-weight: 400;
    text-align: center;
    color: var(--arrowColor);

    &--grey {
      color: var(--arrowColor);
    }
  }
}

.Options {
  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-height: 240px;
  padding: 0;
  border: 1px solid var(--optionsBorder);
  background: var(--optionsBg);
  overflow: auto;
  z-index: 1500;
  box-shadow: 0px 4px 4px var(--shadowColor);
}
</style>



// WEBPACK FOOTER //
// src/components/ColorSelect.vue